import Grid from "@mui/material/Grid2";
import {
  FaLinkedin,
  FaTwitter,
  FaFacebook,
  FaInstagram,
  FaTiktok,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "./FooterStyle.css";
import i18next from "i18next";
import enNews from "../../assets/contenu/news/news_en";
import frNews from "../../assets/contenu/news/news_fr";
import arNews from "../../assets/contenu/news/news_ar";

const Footer = ({ t, data }) => {
  const currentYear = new Date().getFullYear();
  const isRTL = i18next.language === "ar";

  const newsData =
    {
      fr: frNews,
      en: enNews,
      ar: arNews,
    }[i18next.language] || frNews;

  const latestNews = newsData?.blogs?.slice(0, 4) || []; // Get latest 3 news articles

  return (
    <div className={`footer ${isRTL ? "rtl" : ""}`}>
      <div className="footer-container">
        {/* Footer Links */}
        <Grid container spacing={5} justifyContent="center">
          {/* Policy and terms Section */}
          <Grid size={{ xs: 12, sm: 4, md: 3 }} className="footer-section">
            <h4>{t("about_us")}</h4>
            <Link to={`/${i18next.language}`}>
              <div className="address">
                <img src="/logo-historiar-light.png" alt="logo historiar" />
              </div>
            </Link>
            <p style={{ textAlign: isRTL ? "right" : "left" }}>
              <Link to={"/" + i18next.language}>
                <strong>Historiar</strong>
              </Link>{" "}
              {t("about_us_text")}
            </p>
          </Grid>

          {/* Social Section */}
          <Grid size={{ xs: 12, sm: 4, md: 3 }} className="footer-section">
            <h4>{t("sites")}</h4>
            <ul>
              {data?.map((site, index1) => (
                <li key={`${site.link}-${index1}`}>
                  <Link
                    to={`/site/${site.link}/${i18next.language}`}
                    style={{ color: "#f9db1f" }}
                  >
                    {site.name}
                  </Link>
                  {site.locations && (
                    <div style={{ marginLeft: isRTL ? "auto" : "1em" }}>
                      <ul>
                        {site.locations?.map((location, index2) => (
                          <li key={index2} style={{ marginBottom: "-0.3em" }}>
                            <Link
                              to={`/site/${site.link}/location/${location.link}/${i18next.language}`}
                            >
                              ‣ {location.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </Grid>

          {/* Latest News Section */}
          <Grid size={{ xs: 12, sm: 4, md: 3 }} className="footer-section">
            <h4>{t("latest_news")}</h4>
            <ul>
              {latestNews.map((news, index) => (
                <li key={news.id} style={{ marginBottom: "1rem" }}>
                  <Link
                    to={`/article-details/${news.id}/${i18next.language}`}
                    target="_blank"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    <div className="news-item">
                      <strong>{news.title}</strong>
                      <p style={{ fontSize: "0.9rem", color: "#ccc" }}>
                        {news.date} - {news.author}
                      </p>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </Grid>

          {/* Get in touch Section */}
          <Grid size={{ xs: 12, sm: 4, md: 3 }} className="footer-section">
            <h4>{t("get_in_touch")}</h4>
            <div className="social-icons">
              <Link
                to="https://www.facebook.com/p/HISTORIAR-100063614228567/"
                target="_blank"
                className="icon"
              >
                <FaFacebook size={30} />
              </Link>
              <Link
                to="https://twitter.com/HistoriarSa"
                target="_blank"
                className="icon"
              >
                <FaTwitter size={30} />
              </Link>
              <Link
                to="https://www.linkedin.com/company/historiar/"
                target="_blank"
                className="icon"
              >
                <FaLinkedin size={30} />
              </Link>
              <Link
                to="https://www.instagram.com/historiar.io/"
                target="_blank"
                className="icon"
              >
                <FaInstagram size={30} />
              </Link>
              <Link
                to="https://www.tiktok.com/@historiar.io"
                target="_blank"
                className="icon"
              >
                <FaTiktok size={30} />
              </Link>
            </div>
            <br />
            <ul>
              <li>
                <Link to="mailto: contact@historiar.io">
                  contact@historiar.io
                </Link>
              </li>
              <li>
                <Link to="tel:+21622585448">+216 22 585 448</Link>
              </li>
              <li>
                <Link to={`/privacy-policy/${i18next.language}`}>
                  {t("privacy_policy")}
                </Link>
              </li>
            </ul>
          </Grid>
        </Grid>

        {/* Footer Copyright */}
        <p>
          <Link to={"/" + i18next.language} style={{ color: "#f9db1f" }}>
            HISTORIAR
          </Link>
          {" © "}
          {currentYear}
          {" | POWERED BY "}
          <Link to="#" style={{ color: "#f9db1f" }}>
            ETHRAA
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Footer;
